import { render, staticRenderFns } from "./supplierStock.vue?vue&type=template&id=c095df02&"
import script from "./supplierStock.vue?vue&type=script&lang=js&"
export * from "./supplierStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports